export default {"src":"/_next/static/media/bincentive.88426bcf.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};